import React, { memo } from 'react'
import styles from './FinalizationHeader.module.scss'
import { useLocation, useNavigate } from 'react-router-dom';
import { ApplicationRoutes } from '../../../routes';

type Props = {
  onClickSideMenu: () => void
}

const FinalizationHeader: React.FC<Props> = memo((props: Props) => {
  const { onClickSideMenu } = props

  const navigate = useNavigate();
  const location = useLocation();

  const landingRouteChange = () => {
    navigate(ApplicationRoutes.LANDING_PAGE);
  }

  const routeChange = () => {
    navigate(ApplicationRoutes.LOGIN);
  }

  const partnersRouteChange = () => {
    navigate(ApplicationRoutes.PROVIDER_SIGNUP);
  }

  return (
    <div className={styles.container}>
      <img onClick={landingRouteChange} src="../../../../images/solar-recommendation-header-logo.png" alt='Logo' />
      <div className={styles.links}>
        {/* <div className={styles.link}>
          About
        </div> */}
        <button className={`standardButton ${styles.link}`} onClick={partnersRouteChange}>
          Partner Signup
        </button>
        {/* <button className={`standardButton ${styles.button}`} onClick={routeChange}>
          Sign In
        </button> */}
      </div>
      <button className={styles.menuButton} onClick={onClickSideMenu}>
        <img src="../../../icons/menu_icon.svg" alt='Menu' />
      </button>
    </div>
  )
})

export default FinalizationHeader